import React from "react";
import { useTranslation } from "react-i18next";
import { classNames } from "../../Utils";

export const Pagination = ({
  className = "",
  page = 1,
  onPrev = () => {},
  onNext = () => {},
  onPageChange = () => {},
  nextTokens = { 1: null },
  buttonPosition = "",
}) => {
  const { t } = useTranslation();

  let buttonPositionClasses;
  switch (buttonPosition) {
    case "between":
      buttonPositionClasses = "justify-between";
      break;
    case "center":
      buttonPositionClasses = "justify-center";
      break;
    case "end":
      buttonPositionClasses = "justify-end";
      break;
    case "start":
      buttonPositionClasses = "justify-start";
      break;
    default:
      buttonPositionClasses = "justify-between";
      break;
  }

  const handleNextClick = () => {
    const currentPage = page + 1;
    const nextPageToken = nextTokens[currentPage];

    if (nextPageToken) {
      onNext();
    }
  };

  const handlePageClick = (pageNumber) => {
    if (pageNumber === 1) {
      onPageChange(pageNumber);
    }
    if (nextTokens[pageNumber]) {
      onPageChange(pageNumber);
    }
  };

  const renderPageButtons = () => {
    const pages = [];
    const totalPages = Object.keys(nextTokens).length;

    for (let i = 1; i < totalPages; i++) {
      if (nextTokens[i]) {
        pages.push(
          <button
            key={i}
            onClick={() => handlePageClick(i)}
            className={classNames(
              i === page
                ? "border-blue-500 text-blue-600"
                : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300",
              "border-t-2 py-2 px-4 inline-flex items-center text-sm font-medium"
            )}
          >
            {i}
          </button>
        );
      }
    }

    if (nextTokens[totalPages]) {
      pages.push(
        <span
          key="ellipsis"
          className="border-transparent text-gray-500 border-t-2 py-2 px-4 inline-flex items-center text-sm font-medium"
        >
          ...
        </span>
      );
    }

    return pages;
  };

  return (
    <nav
      className={classNames(
        className,
        buttonPositionClasses,
        "bg-white px-4 py-3 gap-2 flex items-center border-t border-gray-200"
      )}
      aria-label="Pagination"
    >
      <button
        type="button"
        disabled={page === 1}
        onClick={onPrev}
        className={classNames(
          page === 1 ? "opacity-50 cursor-not-allowed" : "",
          "relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50"
        )}
      >
        {t("Previous")}
      </button>

      <div className="hidden md:-mt-px md:flex">
        <button
          onClick={() => handlePageClick(1)}
          className={classNames(
            page === 1
              ? "border-blue-500 text-blue-600"
              : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300",
            "border-t-2 py-2 px-4 inline-flex items-center text-sm font-medium"
          )}
        >
          1
        </button>

        {renderPageButtons()}
      </div>

      <button
        type="button"
        disabled={!nextTokens[page + 1]}
        onClick={handleNextClick}
        className={classNames(
          !nextTokens[page + 1] ? "opacity-50 cursor-not-allowed" : "",
          "ml-3 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50"
        )}
      >
        {t("Next")}
      </button>
    </nav>
  );
};
